import React from 'react'
import { Outlet } from 'react-router-dom'

export function Layout() {
    return (
        <section /*style = {{border:'2px solid red'}}*/>
            <Outlet />
        </section>
    )
}

export function CatalogoLayout() {
    return (
        <section /*style = {{border:'1px solid green'}}*/>
            <Outlet />
        </section>
    )
}

export function AdminLayout() {
    return (
        <section /*style = {{border:'2px solid blue'}}*/>
            <Outlet />
        </section>
    )
}
